// @mui
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
//
import { ColumnMapping } from 'src/models';

// ----------------------------------------------------------------------

type Props = {
  mapping: ColumnMapping;
  headers: string[];
  kind: 'miles' | 'fuel';
};

function columnName(headers: string[], index: number) {
  if (index < 0 || index >= headers.length) return null;
  return headers[index] || `Column ${index + 1}`;
}

export default function ColumnMappingCard({ mapping, headers, kind }: Props) {
  const entries: { label: string; column: number }[] =
    kind === 'miles'
      ? [
          { label: 'Truck', column: mapping.vehicleColumn },
          { label: 'State', column: mapping.stateColumn },
          { label: 'Total Miles', column: mapping.totalMilesColumn },
          { label: 'Taxable Miles', column: mapping.taxableMilesColumn },
        ]
      : [
          { label: 'Truck', column: mapping.vehicleColumn },
          { label: 'State', column: mapping.stateColumn },
          { label: 'Gallons', column: mapping.gallonsColumn },
          { label: 'Amount', column: mapping.amountColumn },
        ];

  return (
    <Alert severity="info" icon={false} data-testid="column-mapping-card">
      <AlertTitle>AI detected these columns. Please confirm they look right</AlertTitle>
      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap sx={{ mt: 1 }}>
        {entries.map(({ label, column }) => {
          const name = columnName(headers, column);
          return (
            <Chip
              key={label}
              size="small"
              label={name ? `${name} → ${label}` : `${label}: not found`}
              color={name ? 'default' : 'warning'}
            />
          );
        })}
        {mapping.filterColumn >= 0 && (
          <Chip
            size="small"
            label={`Only rows where ${columnName(headers, mapping.filterColumn)} = ${mapping.filterValue}`}
          />
        )}
      </Stack>
    </Alert>
  );
}
